'use strict';

const LoginHeaderDirective = function () {

  const LoginHeaderController = function ($rootScope) {

    this.ASSETS_DOMAIN = $rootScope.CONST.assets_domain;
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    controller: ['$rootScope', LoginHeaderController],
    controllerAs: 'header',
    templateUrl: 'login/templates/header.tpl.html'
  };
};

module.exports = LoginHeaderDirective;



// WEBPACK FOOTER //
// ./src/app/login/directives/LoginHeaderDirective.js